import { createContextProvider } from '@/modules/common/composables/createContextProvider';

import type { CampaignGroupContext } from './types';

export const provider = createContextProvider<CampaignGroupContext>('CampaignGroup');

export const provideCampaignGroupContext = provider.provideContext;
export const useCampaignGroupContext = provider.useContext;
